import { Component } from "@angular/core";
import { ALLOWED_CHARACTERS } from "src/config/allowed-characters.config";
import { PrefixComponent } from "../../prefix.component";

@Component({
  selector: "app-prefix-bla",
  imports: [],
  templateUrl: "./prefix-bla.component.html",
  styleUrl: "./prefix-bla.component.less",
})
export class PrefixBlaComponent extends PrefixComponent<string> {
  public constructor() {
    super();
    this.post = false;
    this.characters = ALLOWED_CHARACTERS["bla"];
  }
}
